/**
 * Leprendo Header Module
 * Sticky scroll, mobile nav toggle, mega-menu.
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.site-header');
    const toggle = document.querySelector('[data-nav-toggle]');
    const mobileNav = document.querySelector('[data-mobile-nav]');
    const legacyNotice = document.querySelector('.legacy-notice');

    // ── Sticky scroll shadow ─────────────────────────────────────────────────
    if (header) {
      const onScroll = () => {
        header.classList.toggle('scrolled', window.scrollY > 10);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // ── Legacy notice: re-appear whenever user scrolls up ───────────────────
    if (legacyNotice) {
      let lastY = window.scrollY;
      const threshold = 6;
      const onLegacyScroll = () => {
        const y = window.scrollY;
        if (y <= 0) {
          legacyNotice.classList.remove('is-sticky', 'is-hidden');
          lastY = y;
          return;
        }
        const scrollingUp = y < lastY - threshold;
        const scrollingDown = y > lastY + threshold;
        legacyNotice.classList.add('is-sticky');
        if (scrollingUp) legacyNotice.classList.remove('is-hidden');
        if (scrollingDown) legacyNotice.classList.add('is-hidden');
        lastY = y;
      };
      window.addEventListener('scroll', onLegacyScroll, { passive: true });
      onLegacyScroll();
    }

    // ── Mobile nav toggle ────────────────────────────────────────────────────
    if (toggle && mobileNav) {
      toggle.addEventListener('click', () => {
        const open = mobileNav.classList.toggle('open');
        toggle.classList.toggle('open', open);
        toggle.setAttribute('aria-expanded', String(open));
        document.body.style.overflow = open ? 'hidden' : '';
      });

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && mobileNav.classList.contains('open')) {
          mobileNav.classList.remove('open');
          toggle.classList.remove('open');
          toggle.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        }
      });
    }

    // ── Mobile sub-menu expand ───────────────────────────────────────────────
    document.querySelectorAll('[data-mobile-expand]').forEach(btn => {
      btn.addEventListener('click', () => {
        const sub = btn.nextElementSibling;
        if (!sub) return;
        const open = sub.classList.toggle('open');
        btn.setAttribute('aria-expanded', String(open));
        const icon = btn.querySelector('i');
        if (icon) icon.style.transform = open ? 'rotate(180deg)' : '';
      });
    });
  });
})();
